import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38419ccd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bi-tmpl-detail__right__cmpt" }
const _hoisted_2 = { class: "bi-tmpl-detail__right__cmpt__title" }
const _hoisted_3 = { class: "bi-tmpl-detail__right__cmpt-themeColor" }

import { BaseRadio } from 'xrk-components';
import { useDetailCmpt } from '@V/bi-tmpl/src/hooks';

const CHILD_KEY = '101_1';

export default /*#__PURE__*/_defineComponent({
  __name: 'bi-tmpl-detail-101-1',
  setup(__props) {

const THEME_MAPPING = {
  1: {
    color: '#265BA6',
    value:
      '#265BA6,#5BA1D5,#4E56BA,#4EB99C,#6B4EBA,#A44EB9,#9D7CF5,#9BAF65,#3D8D93,#D1A734'
  },
  2: {
    color: '#96643C',
    value:
      '#96643C,#A56190,#9989C4,#98B28C,#C78E60,#6C87CE,#BEA862,#5FAF8A,#69B6D3,#3B88B4'
  },
  3: {
    color: '#A51F08',
    value:
      '#A51F08,#5884BA,#D3B354,#7474B9,#45479B,#04057B,#C288CC,#61A8A3,#96643C,#1669E0'
  },
  4: {
    color: '#7457AC',
    value:
      '#7457AC,#D98F69,#C288CC,#54A8C7,#9498EA,#A754A7,#3D8D93,#D5B970,#94B172,#45479B'
  },
  5: {
    color: '#BEA862',
    value:
      '#BEA862,#DB9854,#9BAF65,#BE7BBE,#6A9DC9,#76BA81,#A44EB9,#265BA6,#7463D3,#96643C'
  },
  6: {
    color: '#3B88B4',
    value:
      '#3B88B4,#7463D3,#B76EC1,#70AF7C,#D5A75E,#61A8A3,#888BD0,#4E56BA,#10CBCB,#FFA767'
  },
  7: {
    color: '#3D8D93',
    value:
      '#3D8D93,#DDB13A,#617FD0,#78B58B,#9779CE,#AAB74A,#888BD0,#4E56BA,#10CBCB,#8247C6'
  },
  8: {
    color: '#6666BE',
    value:
      '#6666BE,#5DB0BF,#8E5DBF,#CCB462,#6DB583,#E0974E,#888BD0,#A3C100,#96643C,#10CBCB'
  },
  9: {
    color: '#5FAF8A',
    value:
      '#5FAF8A,#D5B970,#C28CCB,#69B6D3,#888BD0,#E2A364,#3D8D93,#265BA6,#AAB74A,#9B4E83'
  },
  10: {
    color: '#D1A734',
    value:
      '#D1A734,#94B172,#9B6DD9,#7070DB,#6794CB,#45B7B7,#4E56BA,#96643C,#B94EB9,#D17F2B'
  }
};

const { curItem, onChange } = useDetailCmpt({ childKey: CHILD_KEY });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(curItem).title), 1),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(THEME_MAPPING, (item) => {
        return _createElementVNode("div", {
          class: "bi-tmpl-detail__right__cmpt-themeColor__item",
          key: item.value
        }, [
          _createVNode(_unref(BaseRadio), {
            class: "bi-tmpl-detail__right__cmpt__radio bi-tmpl-detail__right__cmpt__radio--w35",
            value: item.value,
            "model-value": _unref(curItem).value,
            onClick: ($event: any) => (_unref(onChange)(item.value))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                style: _normalizeStyle({
              background: item.color,
              width: '18px',
              height: '18px',
              'border-radius': '2px'
            })
              }, null, 4)
            ]),
            _: 2
          }, 1032, ["value", "model-value", "onClick"])
        ])
      }), 64))
    ])
  ]))
}
}

})